import React from 'react';
import { Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';

export default function RecordingBarPatient({ patient, t, handlePatientClick }) {
  return (
    <Button
      type="text"
      icon={<UserOutlined />}
      className="recording-bar__patient"
      onClick={handlePatientClick}
      disabled={!patient}
      style={{ fontSize: 16 }}
    >
      {patient?.getFullName() || t('session_details_patient.link_patient_title')}
    </Button>
  );
}
